import React, { useEffect, useState } from "react";
import {
    Button, Form, Badge, Card, Spinner, Modal,
    Row, Col, Container, Tabs, Tab, InputGroup
} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Foto from "../Components/Foto";
import "./ferias.css";

const MySwal = withReactContent(Swal);
const avatarPadrao = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23cccccc'><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/></svg>";
const cacheFotos = {};

const parseDataBR = (strData) => {
    if (!strData) return null;
    const partes = strData.split('/');
    if (partes.length === 3) {
        return new Date(partes[2], partes[1] - 1, partes[0]);
    }
    return null;
};

function CardFuncionarioLista({ funcionario, onClick, setFotoSelecionada }) {
    const matricula = funcionario.CHAPA || funcionario.chapa || funcionario.MATRICULA || funcionario.matricula;
    const nome = funcionario.NOME || funcionario.nome;
    const funcao = funcionario.FUNCAO || funcionario.funcao || "Funcionário";
    const loja = funcionario.LOJA || funcionario.loja || funcionario.CODFILIAL || funcionario.codfilial || "3";

    const saldoReal = Number(funcionario.SALDO_REAL ?? funcionario.saldo_real ?? 0);
    const saldoNaoPago = Number(funcionario.SALDO_NAO_PAGO ?? funcionario.saldo_nao_pago ?? 0);
    const saldoNaoEncerrado = Number(funcionario.SALDO_NAO_ENCERRADO ?? funcionario.saldo_nao_encerrado ?? 0);
    
    const temPendenteAssinatura = Boolean(
        funcionario.TEM_PENDENTE ?? 
        funcionario.tem_pendente ?? 
        false
    );

    const [imgSrc, setImgSrc] = useState(() => {
        return cacheFotos[matricula] ? `data:image/jpeg;base64,${cacheFotos[matricula]}` : avatarPadrao;
    });

    useEffect(() => {
        let isMounted = true;
        if (matricula && !cacheFotos[matricula]) {
            api.get(`/usuario/foto/${matricula}`)
                .then(res => {
                    if (isMounted && res.data && res.data.foto) {
                        cacheFotos[matricula] = res.data.foto;
                        setImgSrc(`data:image/jpeg;base64,${res.data.foto}`);
                    }
                })
                .catch(() => { });
        } else if (matricula && cacheFotos[matricula]) {
            setImgSrc(`data:image/jpeg;base64,${cacheFotos[matricula]}`);
        }
        return () => { isMounted = false; };
    }, [matricula]);

    return (
        <Card
            className="shadow-sm border mb-2 bg-white equipamentos-card"
            style={{ cursor: 'pointer', borderRadius: '12px', overflow: 'hidden' }}
            onClick={() => onClick(funcionario)}
        >
            <Card.Body className="p-3">
                <div className="d-flex align-items-center gap-3 mb-2">
                    <img
                        src={imgSrc}
                        alt=""
                        onError={(e) => { e.target.src = avatarPadrao; }}
                        className="rounded-circle border bg-light flex-shrink-0"
                        style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            const fotoLocal = cacheFotos[matricula];
                            setFotoSelecionada({
                                foto: fotoLocal ? `data:image/jpeg;base64,${fotoLocal}` : null,
                                nome: nome,
                                loja: `Loja: ${String(loja || "3").padStart(2, '0')}`
                            });
                        }}
                    />
                    <div className="flex-grow-1">
                        <div className="fw-bold text-dark" style={{ fontSize: '0.95rem', lineHeight: '1.2' }}>
                            {nome}
                        </div>
                        <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                            Matrícula: <strong className="text-dark">{matricula}</strong> • {funcao}
                        </div>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-end gap-1 pt-2 border-top flex-wrap">
                    <Badge bg="dark" style={{ fontSize: '0.65rem', padding: '4px 6px' }}>
                        Loja {String(loja || "").padStart(2, '0')}
                    </Badge>

                    {temPendenteAssinatura && (
                        <Badge bg="secondary" text="white" className="fw-bold" style={{ fontSize: '0.65rem', padding: '4px 6px' }}>
                            <i className="fa-solid fa-clock me-1"></i>Pendente Assinatura
                        </Badge>
                    )}

                    {saldoNaoPago > 0 && (
                        <Badge bg="warning" text="dark" style={{ fontSize: '0.65rem', padding: '4px 6px' }} title="Período vencido sem pagamento">
                            Não Pago: {saldoNaoPago}d
                        </Badge>
                    )}

                    {saldoNaoEncerrado > 0 && (
                        <Badge bg="info" text="white" style={{ fontSize: '0.65rem', padding: '4px 6px' }} title="Período aquisitivo ainda não finalizado">
                            Não encerrado: {saldoNaoEncerrado}d
                        </Badge>
                    )}

                    {saldoReal > 0 ? (
                        <Badge bg="danger" style={{ fontSize: '0.65rem', padding: '4px 6px' }} title="Saldo disponível para gozo">
                            Direito: {saldoReal}d
                        </Badge>
                    ) : (saldoNaoPago === 0 && saldoNaoEncerrado === 0 && !temPendenteAssinatura) ? (
                        <Badge bg="light" text="muted" className="border" style={{ fontSize: '0.62rem', padding: '3px 5px' }}>
                            Sem saldo
                        </Badge>
                    ) : null}
                </div>
            </Card.Body>
        </Card>
    );
}

function ControleFeriasManualMobile() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("consulta");

    const [funcionarios, setFuncionarios] = useState([]);
    const [filtroBusca, setFiltroBusca] = useState("");
    const [filtroStatus, setFiltroStatus] = useState("TODOS");
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(null);

    const [periodos, setPeriodos] = useState([]);
    const [gozosRealizados, setGozosRealizados] = useState([]);
    const [resumoDias, setResumoDias] = useState({
        TOTAL_DIREITO: 0,
        TOTAL_VENDIDOS: 0,
        SALDO_DISPONIVEL: 0
    });

    const [novaPeriodoInicio, setNovaPeriodoInicio] = useState("");
    const [novaPeriodoFim, setNovaPeriodoFim] = useState("");
    const [novoLimiteGozo, setNovoLimiteGozo] = useState("");
    const [novaDataInicioFerias, setNovaDataInicioFerias] = useState("");
    const [novaDataFimFerias, setNovaDataFimFerias] = useState("");
    const [novaDataPagto, setNovaDataPagto] = useState("");
    const [novaDataAviso, setNovaDataAviso] = useState("");
    const [novoDiasDireito, setNovoDiasDireito] = useState(30);
    const [novoDiasVendidos, setNovoDiasVendidos] = useState(0);

    const [gozoDataInicio, setGozoDataInicio] = useState("");
    const [gozoDataFim, setGozoDataFim] = useState("");
    const [gozoDiasCalculados, setGozoDiasCalculados] = useState(0);
    const [gozoObservacao, setGozoObservacao] = useState("");

    const [linkModalData, setLinkModalData] = useState(null);
    const [foto, setFoto] = useState(null);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const usuarioLogado = localStorage.getItem("usuario_matricula") || localStorage.getItem("chapa") || "";
    const permiteRegional = localStorage.getItem("permiteRegional");
    const diretor = localStorage.getItem("diretor");
    const permiteFerias = localStorage.getItem("FERIAS");

    const isDiretor = diretor === "S" || diretor === "1" || diretor === "true" || diretor === true;
    const lojasPermitidas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");

    useEffect(() => {
        const temAcesso = permiteRegional === "S" || isDiretor || permiteFerias === "S" || permiteFerias === "1";

        if (!temAcesso) {
            MySwal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não possui permissão para acessar o Controle de Férias.',
                confirmButtonText: 'OK'
            }).then(() => {
                navigate(-1);
            });
            return;
        }

        carregarTodosFuncionarios();
    }, []);

    const carregarTodosFuncionarios = async () => {
        setLoading(true);
        try {
            const res = await api.get("/usuario/sem-ponto");
            setFuncionarios(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error("Erro ao carregar funcionários:", err);
            toast.error("Erro ao carregar a lista de funcionários.");
        } finally {
            setLoading(false);
        }
    };

    const calcularResumoValido = () => {
        return periodos.reduce((acc, p) => {
            const dataPagto = p.DATA_PAGTO ?? p.data_pagto;
            const isPaga = !!dataPagto && dataPagto !== "Sem registro";

            if (isPaga) {
                acc.direito += Number(p.DIAS_DIREITO ?? p.dias_direito ?? 0);
                acc.vendidos += Number(p.DIAS_VENDIDOS ?? p.dias_vendidos ?? 0);
                acc.saldo += Number(p.SALDO_DIAS ?? p.saldo_dias ?? 0);
            }
            return acc;
        }, { direito: 0, vendidos: 0, saldo: 0 });
    };

    const resumoValido = calcularResumoValido();

    // Filtra períodos pagos e ordenados do mais antigo para o mais recente (FIFO)
    const periodosElegiveisGozo = periodos
        .filter(p => {
            const status = p.STATUS ?? p.status;
            const dataPagto = p.DATA_PAGTO ?? p.data_pagto;
            const isPaga = !!dataPagto && dataPagto !== "Sem registro";
            const saldoDias = Number(p.SALDO_DIAS ?? p.saldo_dias ?? 0);

            return status === 'EM_ABERTO' && isPaga && saldoDias > 0;
        })
        .sort((a, b) => {
            const dtA = parseDataBR(a.PERIODO_INICIO ?? a.periodo_inicio);
            const dtB = parseDataBR(b.PERIODO_INICIO ?? b.periodo_inicio);
            return (dtA || 0) - (dtB || 0);
        });

    const saldoTotalElegivel = periodosElegiveisGozo.reduce((sum, p) => sum + Number(p.SALDO_DIAS ?? p.saldo_dias ?? 0), 0);

    // Verifica se há alguma solicitação pendente de assinatura
    const temSolicitacaoPendente = gozosRealizados.some(g => {
        const st = String(g.STATUS_APROVACAO ?? g.status_aprovacao ?? "").toUpperCase();
        return st === 'PENDENTE';
    });

    useEffect(() => {
        if (novaPeriodoInicio) {
            try {
                const dataIni = new Date(novaPeriodoInicio + "T00:00:00");
                if (!isNaN(dataIni.getTime())) {
                    const dataFimCalculada = new Date(dataIni);
                    dataFimCalculada.setFullYear(dataFimCalculada.getFullYear() + 1);
                    dataFimCalculada.setDate(dataFimCalculada.getDate() - 1);
                    setNovaPeriodoFim(dataFimCalculada.toISOString().split('T')[0]);

                    const dataLimiteCalculada = new Date(dataIni);
                    dataLimiteCalculada.setMonth(dataLimiteCalculada.getMonth() + 23);
                    setNovoLimiteGozo(dataLimiteCalculada.toISOString().split('T')[0]);
                }
            } catch (e) {
                console.error("Erro no cálculo das datas de período", e);
            }
        }
    }, [novaPeriodoInicio]);

    useEffect(() => {
        if (gozoDataInicio && gozoDataFim) {
            try {
                const dtIni = new Date(gozoDataInicio + "T00:00:00");
                const dtFim = new Date(gozoDataFim + "T00:00:00");

                if (!isNaN(dtIni.getTime()) && !isNaN(dtFim.getTime())) {
                    if (dtFim < dtIni) {
                        setGozoDiasCalculados(0);
                    } else {
                        const diffTime = dtFim - dtIni;
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
                        setGozoDiasCalculados(diffDays);
                    }
                }
            } catch (e) {
                console.error("Erro no cálculo dos dias de gozo", e);
            }
        } else {
            setGozoDiasCalculados(0);
        }
    }, [gozoDataInicio, gozoDataFim]);

    const handleSelecionarFuncionario = async (func) => {
        setLoading(true);
        setFuncionarioSelecionado(func);
        setPeriodos([]);
        setGozosRealizados([]);
        resetarFormularios();

        const matriculaAtiva = func.CHAPA || func.chapa || func.MATRICULA || func.matricula;

        if (cacheFotos[matriculaAtiva]) {
            setFoto(cacheFotos[matriculaAtiva]);
        } else {
            setFoto(null);
            api.get(`/usuario/foto/${matriculaAtiva}`)
                .then(res => {
                    if (res.data && res.data.foto) {
                        cacheFotos[matriculaAtiva] = res.data.foto;
                        setFoto(res.data.foto);
                    }
                })
                .catch(() => setFoto(null));
        }

        try {
            await carregarDadosFerias(matriculaAtiva);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const carregarDadosFerias = async (matricula) => {
        try {
            const [resPeriodos, resResumo] = await Promise.all([
                api.get(`/rh/ferias/periodos/${matricula}`),
                api.get(`/rh/ferias/saldo/${matricula}`)
            ]);
            setPeriodos(resPeriodos.data || []);
            setResumoDias(resResumo.data || { TOTAL_DIREITO: 0, TOTAL_VENDIDOS: 0, SALDO_DISPONIVEL: 0 });

            api.get(`/rh/ferias/gozos/${matricula}`)
                .then(resGozos => {
                    setGozosRealizados(resGozos.data || []);
                })
                .catch(err => {
                    console.warn(err);
                    setGozosRealizados([]);
                });

        } catch (err) {
            console.error(err);
            toast.error("Erro ao carregar dados de férias.");
        }
    };

    const resetarFormularios = () => {
        setNovaPeriodoInicio("");
        setNovaPeriodoFim("");
        setNovoLimiteGozo("");
        setNovaDataInicioFerias("");
        setNovaDataFimFerias("");
        setNovaDataPagto("");
        setNovaDataAviso("");
        setNovoDiasDireito(30);
        setNovoDiasVendidos(0);
        setGozoDataInicio("");
        setGozoDataFim("");
        setGozoDiasCalculados(0);
        setGozoObservacao("");
    };

    const handleSalvarPeriodo = async (e) => {
        e.preventDefault();
        if (!novaPeriodoInicio || !novaPeriodoFim || !novoLimiteGozo) {
            toast.warning("Por favor, preencha as datas do período aquisitivo.");
            return;
        }

        setLoading(true);
        const matriculaAtiva = funcionarioSelecionado.CHAPA || funcionarioSelecionado.chapa || funcionarioSelecionado.MATRICULA;
        try {
            await api.post('/rh/ferias/periodo', {
                matricula: Number(matriculaAtiva),
                periodo_inicio: novaPeriodoInicio,
                periodo_fim: novaPeriodoFim,
                limite_gozo: novoLimiteGozo,
                data_inicio_ferias: novaDataInicioFerias || null,
                data_fim_ferias: novaDataFimFerias || null,
                data_pagto: novaDataPagto || null,
                data_aviso: novaDataAviso || null,
                dias_direito: Number(novoDiasDireito),
                dias_vendidos: Number(novoDiasVendidos)
            });

            await MySwal.fire({
                icon: 'success',
                title: 'Período Criado!',
                text: 'Novo período inserido com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });

            resetarFormularios();
            await carregarDadosFerias(matriculaAtiva);
            await carregarTodosFuncionarios();
            setActiveTab("consulta");
        } catch (err) {
            const msg = err.response?.data?.erro || "Erro ao salvar período.";
            MySwal.fire('Erro', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleExcluirGozo = async (gozo) => {
        const idGozo = gozo.ID_GOZO ?? gozo.id_gozo;
        const dtInicio = gozo.DATA_INICIO ?? gozo.data_inicio;
        const dtFim = gozo.DATA_FIM ?? gozo.data_fim;
        const diasGozados = gozo.DIAS_GOZADOS ?? gozo.dias_gozados ?? gozo.DIAS_GOZO ?? gozo.dias_gozo;

        const confirmacao = await MySwal.fire({
            title: 'Excluir Lançamento?',
            text: `Deseja realmente estornar o lançamento de ${diasGozados} dias (${dtInicio} à ${dtFim})? O saldo será devolvido ao colaborador.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, Excluir e Estornar!',
            cancelButtonText: 'Cancelar'
        });

        if (confirmacao.isConfirmed) {
            setLoading(true);
            const matriculaAtiva = funcionarioSelecionado.CHAPA || funcionarioSelecionado.chapa || funcionarioSelecionado.MATRICULA;
            try {
                await api.delete(`/rh/ferias/gozo/${idGozo}`);

                await MySwal.fire({
                    icon: 'success',
                    title: 'Gozo Excluído!',
                    text: 'Lançamento removido e saldo estornado com sucesso.',
                    timer: 2000,
                    showConfirmButton: false
                });

                await carregarDadosFerias(matriculaAtiva);
                await carregarTodosFuncionarios();
            } catch (err) {
                const msg = err.response?.data?.erro || "Erro ao excluir o lançamento de gozo.";
                MySwal.fire('Erro', msg, 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    const formatarDataBR = (dataIso) => {
        if (!dataIso) return "";
        const [ano, mes, dia] = dataIso.split("-");
        return `${dia}/${mes}/${ano}`;
    };

    const handleSalvarGozo = async (e) => {
        e.preventDefault();
        const matriculaAtiva = String(funcionarioSelecionado.CHAPA || funcionarioSelecionado.chapa || funcionarioSelecionado.MATRICULA);

        if (usuarioLogado && String(usuarioLogado).trim() === matriculaAtiva.trim()) {
            MySwal.fire(
                'Ação Não Permitida',
                'Você não pode lançar uma solicitação de férias para a sua própria matrícula.',
                'error'
            );
            return;
        }

        if (temSolicitacaoPendente) {
            MySwal.fire(
                'Assinatura Pendente!',
                'Existe uma solicitação de férias aguardando assinatura deste colaborador. Cancele o lançamento pendente antes de realizar um novo agendamento.',
                'warning'
            );
            return;
        }

        if (periodosElegiveisGozo.length === 0) {
            toast.warning("Não há períodos com saldo disponível para gozo.");
            return;
        }

        if (!gozoDataInicio || !gozoDataFim || gozoDiasCalculados <= 0) {
            toast.warning("Selecione um intervalo de datas válido (A data final deve ser posterior ou igual à data inicial).");
            return;
        }

        if (gozoDiasCalculados > saldoTotalElegivel) {
            toast.error(`A quantidade solicitada (${gozoDiasCalculados}d) excede o saldo disponível total (${saldoTotalElegivel}d).`);
            return;
        }

        const dataIniBR = formatarDataBR(gozoDataInicio);
        const dataFimBR = formatarDataBR(gozoDataFim);

        // Pega o ID do primeiro período (o backend recalculará e fará a distribuição automática em lote)
        const periodoInicial = periodosElegiveisGozo[0];
        const idPeriodoInicial = periodoInicial.ID_PERIODO ?? periodoInicial.id_periodo;

        const confirmacao = await MySwal.fire({
            title: 'Gerar Solicitação de Férias?',
            text: `Será gerado um link de confirmação para o colaborador assinar ${gozoDiasCalculados} dia(s) de férias (${dataIniBR} à ${dataFimBR}). O abatimento será distribuído automaticamente entre os períodos disponíveis.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, Gerar Link',
            cancelButtonText: 'Cancelar'
        });

        if (confirmacao.isConfirmed) {
            setLoading(true);
            try {
                const res = await api.post('/rh/ferias/gozo/solicitar', {
                    id_periodo: idPeriodoInicial,
                    matricula: Number(matriculaAtiva),
                    data_inicio: gozoDataInicio,
                    data_fim: gozoDataFim,
                    dias_gozados: gozoDiasCalculados,
                    observacao: gozoObservacao,
                    usuario_solicitante: usuarioLogado
                });

                const origin = window.location.origin;
                const token = res.data?.token || res.data?.TOKEN;
                const linkDinamico = `${origin}/ferias/confirmar?token=${token}`;

                setLinkModalData({
                    link: linkDinamico,
                    nome: funcionarioSelecionado.NOME || funcionarioSelecionado.nome,
                    dias: gozoDiasCalculados,
                    inicio: dataIniBR,
                    fim: dataFimBR
                });

                resetarFormularios();
                await carregarDadosFerias(matriculaAtiva);
                await carregarTodosFuncionarios();
                setActiveTab("consulta");
            } catch (err) {
                const msg = err.response?.data?.erro || "Erro ao solicitar gozo de férias.";
                MySwal.fire('Erro', msg, 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    const funcionariosFiltrados = funcionarios.filter(f => {
        const lojaRaw = String(f.LOJA || f.loja || f.CODFILIAL || f.codfilial || "").trim();
        const lojaNum = parseInt(lojaRaw, 10);

        if (!isDiretor && Array.isArray(lojasPermitidas) && lojasPermitidas.length > 0) {
            const pertenceLojaPermitida = lojasPermitidas.some(l => Number(l) === lojaNum || String(l).trim() === lojaRaw);
            if (!pertenceLojaPermitida) return false;
        }

        const saldoReal = Number(f.SALDO_REAL ?? f.saldo_real ?? 0);
        const saldoNaoPago = Number(f.SALDO_NAO_PAGO ?? f.saldo_nao_pago ?? 0);
        const saldoNaoEncerrado = Number(f.SALDO_NAO_ENCERRADO ?? f.saldo_nao_encerrado ?? 0);
        
        const temPendenteAssinatura = Boolean(f.TEM_PENDENTE ?? f.tem_pendente ?? false);

        if (filtroStatus === "NAO_PAGO" && saldoNaoPago <= 0) return false;
        if (filtroStatus === "NAO_ENCERRADO" && saldoNaoEncerrado <= 0) return false;
        if (filtroStatus === "SALDO_ABERTO" && saldoReal <= 0) return false;
        if (filtroStatus === "PENDENTE_ASSINATURA" && !temPendenteAssinatura) return false;

        const termo = filtroBusca.toLowerCase().trim();
        if (!termo) return true;

        const nome = (f.NOME || f.nome || "").toLowerCase();
        const chapa = String(f.CHAPA || f.chapa || f.MATRICULA || f.matricula || "").toLowerCase();
        const lojaPadded = String(lojaNum).padStart(2, '0');

        const apenasNumerosBusca = termo.replace(/\D/g, "");
        const numBusca = apenasNumerosBusca ? parseInt(apenasNumerosBusca, 10) : null;

        const matchNomeOrChapa = nome.includes(termo) || chapa.includes(termo);

        const matchLoja = (
            lojaRaw.toLowerCase() === termo ||
            lojaPadded === termo ||
            `loja ${lojaRaw}`.toLowerCase().includes(termo) ||
            `loja ${lojaPadded}`.toLowerCase().includes(termo) ||
            (numBusca !== null && !isNaN(numBusca) && numBusca === lojaNum && termo.includes("loja"))
        );

        return matchNomeOrChapa || matchLoja;
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />

            <Container className="px-3 mt-4 pt-5 mb-5" style={{ flex: 1, maxWidth: '850px' }}>

                {!funcionarioSelecionado ? (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0 text-dark fw-bold">
                                <i className="fa-solid fa-plane-departure text-danger me-2"></i>Controle de Férias (Sem Ponto)
                            </h5>
                        </div>

                        <Card className="shadow-sm border-0 bg-transparent mb-4">
                            <Card.Body className="p-0">
                                <Form.Group className="mb-3 bg-white p-3 rounded-3 border shadow-sm">
                                    <InputGroup className="mb-2">
                                        <InputGroup.Text className="bg-white border-end-0">
                                            <i className="fa-solid fa-magnifying-glass text-muted"></i>
                                        </InputGroup.Text>
                                        <Form.Control
                                            className="border-start-0"
                                            placeholder="Filtrar por nome, matrícula ou loja..."
                                            value={filtroBusca}
                                            onChange={(e) => setFiltroBusca(e.target.value)}
                                            style={{ fontSize: '0.95rem' }}
                                        />
                                        {filtroBusca && (
                                            <Button variant="outline-secondary" onClick={() => setFiltroBusca("")}>
                                                Limpar
                                            </Button>
                                        )}
                                    </InputGroup>

                                    {/* BOTÕES DE FILTRO RÁPIDO */}
                                    <div className="d-flex gap-1 flex-wrap pt-1">
                                        <Button
                                            size="sm"
                                            variant={filtroStatus === "TODOS" ? "danger" : "outline-secondary"}
                                            className={filtroStatus === "TODOS" ? "btn-arbor-primary" : ""}
                                            onClick={() => setFiltroStatus("TODOS")}
                                            style={{ fontSize: '0.75rem', borderRadius: '20px' }}
                                        >
                                            Todos
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant={filtroStatus === "NAO_PAGO" ? "warning" : "outline-warning"}
                                            onClick={() => setFiltroStatus(filtroStatus === "NAO_PAGO" ? "TODOS" : "NAO_PAGO")}
                                            style={{ fontSize: '0.75rem', borderRadius: '20px' }}
                                        >
                                            ⚠️ Não Pago
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant={filtroStatus === "NAO_ENCERRADO" ? "info" : "outline-info"}
                                            onClick={() => setFiltroStatus(filtroStatus === "NAO_ENCERRADO" ? "TODOS" : "NAO_ENCERRADO")}
                                            style={{ fontSize: '0.75rem', borderRadius: '20px' }}
                                        >
                                            ⏳ Não Encerrado
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant={filtroStatus === "SALDO_ABERTO" ? "danger" : "outline-danger"}
                                            onClick={() => setFiltroStatus(filtroStatus === "SALDO_ABERTO" ? "TODOS" : "SALDO_ABERTO")}
                                            style={{ fontSize: '0.75rem', borderRadius: '20px' }}
                                        >
                                            🔴 Saldo Aberto
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant={filtroStatus === "PENDENTE_ASSINATURA" ? "dark" : "outline-dark"}
                                            onClick={() => setFiltroStatus(filtroStatus === "PENDENTE_ASSINATURA" ? "TODOS" : "PENDENTE_ASSINATURA")}
                                            style={{ fontSize: '0.75rem', borderRadius: '20px' }}
                                        >
                                            ⌛ Pendente
                                        </Button>
                                    </div>
                                </Form.Group>

                                <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 250px)' }}>
                                    {funcionariosFiltrados.length === 0 ? (
                                        <Card className="border p-4 text-center text-muted small bg-white rounded-3 shadow-sm">
                                            Nenhum colaborador encontrado para os filtros selecionados.
                                        </Card>
                                    ) : (
                                        <div className="d-flex flex-column gap-1">
                                            {funcionariosFiltrados.map((f) => {
                                                const matricula = f.CHAPA || f.chapa || f.MATRICULA || f.matricula;
                                                return (
                                                    <CardFuncionarioLista
                                                        key={matricula}
                                                        funcionario={f}
                                                        onClick={handleSelecionarFuncionario}
                                                        setFotoSelecionada={setFotoSelecionada}
                                                    />
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                ) : (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3 bg-white p-3 rounded-3 shadow-sm border">
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="fw-bold d-flex align-items-center gap-2 btn-arbor-outline"
                                onClick={() => setFuncionarioSelecionado(null)}
                                style={{ borderRadius: '6px', padding: '6px 14px' }}
                            >
                                <i className="fa-solid fa-arrow-left"></i> Voltar à Lista
                            </Button>
                            <Badge bg="danger" className="p-2 btn-arbor-primary" style={{ fontSize: '0.8rem' }}>Sem Ponto</Badge>
                        </div>

                        <Card className="shadow-sm border-0 p-3 bg-white mb-4 rounded-3">
                            <div className="border-bottom pb-3 mb-3 d-flex align-items-center gap-3">
                                <img
                                    src={foto ? `data:image/jpeg;base64,${foto}` : avatarPadrao}
                                    alt=""
                                    onError={(e) => { e.target.src = avatarPadrao; }}
                                    className="rounded-circle border bg-light"
                                    style={{ width: '65px', height: '65px', objectFit: 'cover', cursor: 'pointer' }}
                                    onClick={() => {
                                        setFotoSelecionada({
                                            foto: foto ? `data:image/jpeg;base64,${foto}` : null,
                                            nome: funcionarioSelecionado.NOME || funcionarioSelecionado.nome,
                                            loja: `Loja: ${String(funcionarioSelecionado.LOJA || funcionarioSelecionado.loja || "3").padStart(2, '0')}`
                                        });
                                    }}
                                />
                                <div className="text-truncate">
                                    <h6 className="fw-bold text-dark mb-1 text-truncate" style={{ fontSize: '1.1rem' }}>
                                        {funcionarioSelecionado.NOME || funcionarioSelecionado.nome}
                                    </h6>
                                    <div className="text-muted small">
                                        Matrícula: <strong className="text-dark">{funcionarioSelecionado.CHAPA || funcionarioSelecionado.chapa}</strong>
                                    </div>
                                    <div className="text-muted small">
                                        Função: <strong className="text-dark">{funcionarioSelecionado.FUNCAO || funcionarioSelecionado.funcao || "Funcionário"}</strong>
                                    </div>
                                </div>
                            </div>

                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => {
                                    setActiveTab(k);
                                    resetarFormularios();
                                }}
                                className="mb-3 border-bottom-0"
                                variant="pills"
                                fill
                            >
                                {/* ABA 1: SALDOS */}
                                <Tab eventKey="consulta" title="Saldos">
                                    <Row className="g-2 mb-3">
                                        <Col xs={4}>
                                            <div className="text-center border rounded p-2 bg-white">
                                                <div className="text-muted" style={{ fontSize: '0.65rem' }}>Direito</div>
                                                <div className="fw-bold text-secondary" style={{ fontSize: '1.1rem' }}>
                                                    {resumoValido.direito}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="text-center border rounded p-2 bg-white">
                                                <div className="text-muted" style={{ fontSize: '0.65rem' }}>Abono</div>
                                                <div className="fw-bold text-warning" style={{ fontSize: '1.1rem' }}>
                                                    {resumoValido.vendidos}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="text-center border-0 rounded p-2 bg-danger text-white btn-arbor-primary">
                                                <div className="text-white-50" style={{ fontSize: '0.65rem' }}>Saldo Real</div>
                                                <div className="fw-bold" style={{ fontSize: '1.1rem' }}>
                                                    {resumoValido.saldo}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <h6 className="fw-bold text-dark mb-2 small">Períodos Aquisitivos & Férias</h6>
                                    {periodos.length === 0 ? (
                                        <div className="text-muted text-center py-3 border rounded bg-light small">
                                            Nenhum período registrado.
                                        </div>
                                    ) : (
                                        periodos.map((p) => {
                                            const idPeriodo = p.ID_PERIODO ?? p.id_periodo;
                                            const periodoInicio = p.PERIODO_INICIO ?? p.periodo_inicio;
                                            const periodoFim = p.PERIODO_FIM ?? p.periodo_fim;
                                            const dataInicioFerias = p.DATA_INICIO ?? p.data_inicio;
                                            const dataFimFerias = p.DATA_FIM ?? p.data_fim;
                                            const dataPagto = p.DATA_PAGTO ?? p.data_pagto;
                                            const dataAviso = p.DATA_AVISO ?? p.data_aviso;
                                            const limiteGozo = p.LIMITE_GOZO ?? p.limite_gozo;
                                            const diasDireito = p.DIAS_DIREITO ?? p.dias_direito;
                                            const diasVendidos = p.DIAS_VENDIDOS ?? p.dias_vendidos;
                                            const saldoDias = p.SALDO_DIAS ?? p.saldo_dias;
                                            const status = p.STATUS ?? p.status;

                                            const isPaga = !!dataPagto && dataPagto !== "Sem registro";

                                            const dataFimObj = parseDataBR(periodoFim);
                                            const hoje = new Date();
                                            hoje.setHours(0, 0, 0, 0);

                                            const isPeriodoNaoEncerrado = dataFimObj ? dataFimObj > hoje : false;

                                            return (
                                                <Card
                                                    key={idPeriodo}
                                                    className={`border shadow-none mb-2 p-2 rounded-3 ${isPaga ? 'bg-light' : 'border-warning bg-white'}`}
                                                    style={!isPaga ? { borderWidth: '2px', borderStyle: 'dashed' } : {}}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <span className="fw-bold text-dark small">
                                                            Período Aquisitivo: {periodoInicio || "N/I"} a {periodoFim || "N/I"}
                                                        </span>

                                                        {isPaga ? (
                                                            <Badge bg={status === "QUITADO" ? "success" : "warning"} text={status === "QUITADO" ? "white" : "dark"} style={{ fontSize: '0.65rem' }}>
                                                                {status}
                                                            </Badge>
                                                        ) : isPeriodoNaoEncerrado ? (
                                                            <Badge bg="info" text="white" className="fw-bold" style={{ fontSize: '0.65rem' }}>
                                                                ⏳ PERÍODO NÃO ENCERRADO
                                                            </Badge>
                                                        ) : (
                                                            <Badge bg="warning" text="dark" className="fw-bold" style={{ fontSize: '0.65rem' }}>
                                                                ⚠️ NÃO PAGO (NÃO CONSIDERAR SALDO)
                                                            </Badge>
                                                        )}
                                                    </div>

                                                    <div className={`small fw-bold mb-1 ${isPaga ? 'text-danger' : 'text-muted'}`} style={{ fontSize: '0.82rem' }}>
                                                        Férias (RM): {isPaga && dataInicioFerias ? `${dataInicioFerias} até ${dataFimFerias}` : 'Aguardando rodar / lançamento de férias'}
                                                    </div>

                                                    <div className={`d-flex gap-3 text-muted small mb-1 p-1 rounded border ${isPaga ? 'bg-white' : 'bg-light text-warning'}`} style={{ fontSize: '0.75rem' }}>
                                                        <span>Pagamento: <strong className={isPaga ? "text-dark" : "text-danger"}>{dataPagto || "Sem registro"}</strong></span>
                                                        <span>•</span>
                                                        <span>Aviso: <strong className={isPaga ? "text-dark" : "text-muted"}>{dataAviso || "Sem registro"}</strong></span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small text-muted border-top pt-1 mt-1">
                                                        <span>Direito: <strong>{diasDireito}d</strong> | Vendidos: <strong>{diasVendidos}d</strong></span>

                                                        {isPaga ? (
                                                            <span className="text-danger fw-bold">Saldo: {saldoDias} dias</span>
                                                        ) : (
                                                            <span className="text-muted fw-bold text-decoration-line-through" title="Saldo suspenso aguardando finalização/pagamento do período">
                                                                Saldo: {saldoDias}d (Bloqueado)
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="text-danger small mt-1" style={{ fontSize: '0.72rem' }}>
                                                        Limite p/ gozo: <strong>{limiteGozo}</strong>
                                                    </div>
                                                </Card>
                                            );
                                        })
                                    )}

                                    <h6 className="fw-bold text-dark mb-2 mt-3 small">Gozos Realizados e Solicitações</h6>
                                    {gozosRealizados.length === 0 ? (
                                        <div className="text-muted text-center py-3 border rounded bg-light small">
                                            Nenhum gozo registrado.
                                        </div>
                                    ) : (
                                        gozosRealizados.map((g, idx) => {
                                            const idGozo = g.ID_GOZO ?? g.id_gozo ?? idx;
                                            const dtInicio = g.DATA_INICIO ?? g.data_inicio;
                                            const dtFim = g.DATA_FIM ?? g.data_fim;
                                            const diasGozados = g.DIAS_GOZADOS ?? g.dias_gozados ?? g.DIAS_GOZO ?? g.dias_gozo;
                                            const obs = g.OBSERVACAO ?? g.observacao ?? "-";

                                            const statusAprovacao = String(g.STATUS_APROVACAO ?? g.status_aprovacao ?? "APROVADO").toUpperCase();
                                            const tokenApp = g.TOKEN_APROVACAO ?? g.token_aprovacao;

                                            const isPendente = statusAprovacao === 'PENDENTE';

                                            return (
                                                <Card key={idGozo} className={`border shadow-none mb-2 p-2 rounded-3 ${isPendente ? 'bg-light border-warning' : 'bg-white'}`}>
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span className="fw-bold text-dark small">{dtInicio} até {dtFim}</span>

                                                            {isPendente ? (
                                                                <Badge bg="warning" text="dark" style={{ fontSize: '0.62rem' }}>
                                                                    ⌛ PENDENTE DE ASSINATURA
                                                                </Badge>
                                                            ) : (
                                                                <Badge bg="success" style={{ fontSize: '0.62rem' }}>
                                                                    ✓ ASSINADO
                                                                </Badge>
                                                            )}
                                                        </div>

                                                        <div className="d-flex align-items-center gap-2">
                                                            <Badge bg={isPendente ? "secondary" : "danger"} style={{ fontSize: '0.65rem' }}>
                                                                -{diasGozados}d
                                                            </Badge>

                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                className="py-0 px-2 fw-bold"
                                                                style={{ fontSize: '0.7rem', lineHeight: '1.5' }}
                                                                title="Cancelar lançamento"
                                                                onClick={() => handleExcluirGozo(g)}
                                                            >
                                                                ✕
                                                            </Button>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center text-muted small pt-1 border-top mt-1" style={{ fontSize: '0.75rem' }}>
                                                        <span className="text-truncate">Obs: {obs}</span>

                                                        {isPendente && tokenApp && (
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                className="py-0 px-2 fw-bold btn-arbor-outline"
                                                                style={{ fontSize: '0.7rem' }}
                                                                onClick={() => {
                                                                    const origin = window.location.origin;
                                                                    const linkReenvio = `${origin}/ferias/confirmar?token=${tokenApp}`;
                                                                    navigator.clipboard.writeText(linkReenvio);
                                                                    toast.success("Link de assinatura copiado com sucesso!");
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-copy me-1"></i>Copiar Link
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Card>
                                            );
                                        })
                                    )}
                                </Tab>

                                {/* ABA 2: NOVO PERÍODO */}
                                <Tab eventKey="cadastro_periodo" title="+ Período">
                                    <div className="py-2">
                                        <Form onSubmit={handleSalvarPeriodo}>
                                            <h6 className="fw-bold text-dark mb-2 small">Período Aquisitivo</h6>
                                            <Form.Group className="mb-2">
                                                <Form.Label className="small fw-bold">Início do Período Aquisitivo</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    required
                                                    value={novaPeriodoInicio}
                                                    onChange={(e) => setNovaPeriodoInicio(e.target.value)}
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label className="small fw-bold text-muted">Fim do Período (Automático)</Form.Label>
                                                <Form.Control type="date" disabled readOnly value={novaPeriodoFim} />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="small fw-bold text-danger">Limite de Gozo (Data Máxima)</Form.Label>
                                                <Form.Control type="date" disabled readOnly value={novoLimiteGozo} />
                                            </Form.Group>

                                            <h6 className="fw-bold text-dark mb-2 mt-3 small border-top pt-2">Dados das Férias (Opcional)</h6>
                                            <Row className="g-2 mb-2">
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Início das Férias</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={novaDataInicioFerias}
                                                            onChange={(e) => setNovaDataInicioFerias(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Fim das Férias</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={novaDataFimFerias}
                                                            onChange={(e) => setNovaDataFimFerias(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row className="g-2 mb-3">
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Data de Pagamento</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={novaDataPagto}
                                                            onChange={(e) => setNovaDataPagto(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Data do Aviso</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={novaDataAviso}
                                                            onChange={(e) => setNovaDataAviso(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row className="g-2 mb-3 border-top pt-2">
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Dias de Direito</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            max="30"
                                                            required
                                                            value={novoDiasDireito}
                                                            onChange={(e) => setNovoDiasDireito(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={6}>
                                                    <Form.Group>
                                                        <Form.Label className="small fw-bold">Dias Vendidos</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            max="30"
                                                            required
                                                            value={novoDiasVendidos}
                                                            onChange={(e) => setNovoDiasVendidos(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <div className="d-grid gap-2">
                                                <Button variant="danger" type="submit" className="btn-arbor-primary fw-bold">Incluir Período</Button>
                                                <Button variant="outline-secondary" size="sm" onClick={resetarFormularios}>Limpar</Button>
                                            </div>
                                        </Form>
                                    </div>
                                </Tab>

                                {/* ABA 3: LANÇAR GOZO (SOLICITAR COM LINK) */}
                                <Tab eventKey="cadastro_gozo" title="+ Gozo">
                                    <div className="py-2">
                                        {temSolicitacaoPendente ? (
                                            <div className="alert alert-warning text-center rounded-3 p-3 mb-3 shadow-sm" role="alert">
                                                <i className="fa-solid fa-triangle-exclamation fa-2x mb-2 d-block text-warning"></i>
                                                <strong className="d-block mb-1">Solicitação de Assinatura Pendente</strong>
                                                <span className="small text-dark">
                                                    Existe um agendamento de férias aguardando a assinatura do colaborador. Cancele o lançamento pendente na aba <strong>Saldos</strong> antes de solicitar um novo período.
                                                </span>
                                            </div>
                                        ) : (
                                            <>
                                                <h6 className="fw-bold text-secondary mb-2 small">Períodos Habilitados (Abatimento Automático FIFO):</h6>

                                                {periodosElegiveisGozo.length === 0 ? (
                                                    <div className="text-muted text-center py-3 border rounded bg-light small mb-3">
                                                        Nenhum período disponível com pagamento verificado.
                                                    </div>
                                                ) : (
                                                    <div className="mb-3">
                                                        {periodosElegiveisGozo.map((p) => {
                                                            const idPeriodo = p.ID_PERIODO ?? p.id_periodo;
                                                            const periodoInicio = p.PERIODO_INICIO ?? p.periodo_inicio;
                                                            const periodoFim = p.PERIODO_FIM ?? p.periodo_fim;
                                                            const saldoDias = p.SALDO_DIAS ?? p.saldo_dias;

                                                            return (
                                                                <Card key={idPeriodo} className="mb-2 p-2 shadow-none border rounded-3 bg-light">
                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                        <span className="small text-dark fw-bold">{periodoInicio} a {periodoFim}</span>
                                                                        <Badge bg="danger" className="btn-arbor-primary">{saldoDias} d</Badge>
                                                                    </div>
                                                                </Card>
                                                            );
                                                        })}
                                                        <div className="text-end small text-muted mt-1">
                                                            Saldo Total Disponível: <strong className="text-danger">{saldoTotalElegivel} dia(s)</strong>
                                                        </div>
                                                    </div>
                                                )}

                                                <Form onSubmit={handleSalvarGozo} className="border-top pt-3 mt-3">
                                                    <h6 className="fw-bold text-dark mb-2 small">Dados do Afastamento:</h6>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="small fw-bold">Data de Início</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            required
                                                            value={gozoDataInicio}
                                                            onChange={(e) => setGozoDataInicio(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="small fw-bold">Data de Término</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            required
                                                            value={gozoDataFim}
                                                            onChange={(e) => setGozoDataFim(e.target.value)}
                                                        />
                                                    </Form.Group>

                                                    <div className="text-center bg-light rounded p-2 mb-3 border">
                                                        <span className="small text-muted d-block">Dias Calculados:</span>
                                                        <span className={`h5 fw-bold ${gozoDiasCalculados > saldoTotalElegivel ? 'text-danger' : 'text-success'}`}>
                                                            {gozoDiasCalculados} dia(s)
                                                        </span>
                                                    </div>

                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="small fw-bold">Observações</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Ex: Abatimento de férias divididas"
                                                            value={gozoObservacao}
                                                            onChange={(e) => setGozoObservacao(e.target.value)}
                                                        />
                                                    </Form.Group>

                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            variant="danger"
                                                            type="submit"
                                                            className="btn-arbor-primary fw-bold"
                                                            disabled={gozoDiasCalculados <= 0 || gozoDiasCalculados > saldoTotalElegivel}
                                                        >
                                                            Gerar Link de Assinatura das Férias
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </>
                                        )}
                                    </div>
                                </Tab>
                            </Tabs>
                        </Card>
                    </div>
                )}
            </Container>

            <Footer />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.loja}
                info02=""
            />

            {/* MODAL DE DADOS E ENVIO DO LINK DO WHATSAPP */}
            <Modal
                show={!!linkModalData}
                onHide={() => setLinkModalData(null)}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 mb-0 fw-bold text-white">
                        <i className="fa-solid fa-link me-2"></i>Link de Confirmação Gerado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <p className="small text-muted mb-2">
                        Envie o link abaixo para <strong>{linkModalData?.nome}</strong> para que ele(a) confirme o gozo de <strong>{linkModalData?.dias} dias</strong> de férias ({linkModalData?.inicio} à {linkModalData?.fim}):
                    </p>
                    <Form.Control
                        type="text"
                        readOnly
                        value={linkModalData?.link || ""}
                        className="bg-light mb-3 small fw-bold text-danger"
                    />
                    <div className="d-grid gap-2">
                        <Button
                            variant="danger"
                            className="btn-arbor-primary fw-bold"
                            onClick={() => {
                                navigator.clipboard.writeText(linkModalData?.link || "");
                                toast.success("Link copiado para a área de transferência!");
                            }}
                        >
                            <i className="fa-solid fa-copy me-2"></i>Copiar Link de Assinatura
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={loading}
                backdrop="static"
                keyboard={false}
                centered
                size="sm"
                contentClassName="bg-transparent border-0"
            >
                <Modal.Body className="text-center">
                    <Spinner animation="border" style={{ color: '#8b0000', width: '3rem', height: '3rem' }} />
                    <div className="text-light mt-2 fw-bold">Processando...</div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ControleFeriasManualMobile;